import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Loader2, Mail, MapPin, Phone, Send } from "lucide-react";
import { PromoStrip } from "../components/PromoStrip";
import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { CookieBanner } from "../components/CookieBanner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Contatti() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/contact`, form);
      toast.success("Messaggio inviato! Ti risponderemo al più presto.");
      setForm({ name: "", email: "", message: "" });
    } catch (err) {
      console.error(err);
      toast.error("Invio non riuscito. Controlla i campi e riprova.");
    } finally {
      setLoading(false);
    }
  };

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  return (
    <div data-testid="contatti-page" className="bg-[#0d0718] text-[#ede8f5] min-h-screen antialiased">
      <PromoStrip />
      <Navbar />
      <main className="px-6 py-20">
        <div className="max-w-4xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12">
          <div>
            <span className="text-xs uppercase tracking-widest text-[#a020f0] font-bold mono-font">Parliamone</span>
            <h1 className="display-font text-4xl md:text-5xl uppercase text-white mt-2 mb-6">Contattami</h1>
            <p className="text-sm text-[#cbd5e1] leading-relaxed mb-8">
              Dubbi su quale pacchetto scegliere, o vuoi valutare sessioni di persona nella tua zona?
              Scrivimi: ti rispondo personalmente.
            </p>
            <div className="space-y-4 text-sm">
              <div className="flex items-center gap-3 text-[#cbd5e1]">
                <Mail className="w-5 h-5 text-[#a020f0]" />
                <a data-testid="contact-email-link" href="mailto:mpcoaching.online@gmail.com" className="hover:text-white transition-colors">
                  mpcoaching.online@gmail.com
                </a>
              </div>
              <div className="flex items-center gap-3 text-[#cbd5e1]">
                <Phone className="w-5 h-5 text-[#a020f0]" />
                <a data-testid="contact-phone-link" href="tel:+393933111439" className="hover:text-white transition-colors">
                  393 311 1439
                </a>
              </div>
              <div className="flex items-center gap-3 text-[#cbd5e1]">
                <MapPin className="w-5 h-5 text-[#a020f0]" />
                <span>Coaching online in tutta Italia • Di persona a Torino (Via Fratelli Garrone 79) su appuntamento</span>
              </div>
            </div>
          </div>
          <form data-testid="contact-form" onSubmit={submit}
            className="p-6 rounded-2xl bg-[#120a21] border border-[#2d1b4e] space-y-4">
            <div>
              <label htmlFor="contact-name" className="block text-xs uppercase font-bold tracking-wider text-[#94a3b8] mb-2">Nome</label>
              <input id="contact-name" data-testid="contact-name-input" required minLength={2}
                value={form.name} onChange={set("name")}
                className="w-full px-4 py-3 rounded-xl bg-[#1a0f2e] border border-[#3b2364] text-white text-sm focus:outline-none focus:border-[#a020f0] transition-colors"
                placeholder="Il tuo nome" />
            </div>
            <div>
              <label htmlFor="contact-email" className="block text-xs uppercase font-bold tracking-wider text-[#94a3b8] mb-2">Email</label>
              <input id="contact-email" data-testid="contact-email-input" type="email" required
                value={form.email} onChange={set("email")}
                className="w-full px-4 py-3 rounded-xl bg-[#1a0f2e] border border-[#3b2364] text-white text-sm focus:outline-none focus:border-[#a020f0] transition-colors"
                placeholder="nome@email.it" />
            </div>
            <div>
              <label htmlFor="contact-message" className="block text-xs uppercase font-bold tracking-wider text-[#94a3b8] mb-2">Messaggio</label>
              <textarea id="contact-message" data-testid="contact-message-input" required minLength={5} rows={5}
                value={form.message} onChange={set("message")}
                className="w-full px-4 py-3 rounded-xl bg-[#1a0f2e] border border-[#3b2364] text-white text-sm focus:outline-none focus:border-[#a020f0] transition-colors resize-none"
                placeholder="Raccontami il tuo obiettivo..." />
            </div>
            <button data-testid="contact-submit-button" type="submit" disabled={loading}
              className="w-full py-3.5 rounded-xl bg-gradient-to-r from-[#6a0dad] to-[#a020f0] hover:brightness-110 text-white font-bold text-xs uppercase tracking-wider transition-[filter] disabled:opacity-60 flex items-center justify-center gap-2">
              {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />}
              {loading ? "Invio in corso..." : "Invia Messaggio"}
            </button>
          </form>
        </div>
      </main>
      <Footer />
      <CookieBanner />
    </div>
  );
}
